import { Trash2 } from "lucide-react";

const statusColor = { new: "#0055FF", contacted: "#FF5500", closed: "#84CC16" };

export const EnquiriesPanel = ({ items, onStatus, onDelete }) => {
  if (!items.length) return <p data-testid="enquiries-empty" className="rounded-3xl bg-white p-10 text-center text-slate-600">No enquiries yet. They'll appear here when someone submits the contact form.</p>;
  return (
    <div data-testid="enquiries-list" className="space-y-4">
      {items.map((e) => (
        <article key={e.id} data-testid={`enquiry-${e.id}`} className="rounded-3xl bg-white p-6 ring-1 ring-slate-900/5">
          <div className="flex flex-wrap items-start justify-between gap-4">
            <div>
              <h3 className="font-display text-xl font-extrabold">{e.name}</h3>
              <p className="text-sm text-slate-600">{e.contact} · {new Date(e.created_at).toLocaleString()}</p>
            </div>
            <div className="flex items-center gap-2">
              <select data-testid={`enquiry-status-${e.id}`} value={e.status} onChange={(ev) => onStatus(e, ev.target.value)} className="rounded-full border-2 px-3 py-1.5 text-sm font-bold" style={{ borderColor: statusColor[e.status], color: statusColor[e.status] }}>
                <option value="new">New</option><option value="contacted">Contacted</option><option value="closed">Closed</option>
              </select>
              <button data-testid={`enquiry-delete-${e.id}`} aria-label="Delete enquiry" onClick={() => onDelete(e)} className="grid h-9 w-9 place-items-center rounded-full text-slate-500 hover:bg-[#FFF1F2] hover:text-[#BE123C]"><Trash2 className="h-4 w-4" /></button>
            </div>
          </div>
          <div className="mt-3 flex flex-wrap gap-2 text-xs font-bold">
            {e.service && <span className="rounded-full bg-[#EFF6FF] px-3 py-1 text-[#0043cc]">{e.service}</span>}
            <span className="rounded-full bg-slate-100 px-3 py-1 text-slate-600">Email: {e.email_status}</span>
          </div>
          <p className="mt-4 whitespace-pre-wrap text-slate-700">{e.brief}</p>
        </article>
      ))}
    </div>
  );
};
